import BaseApi from "./BaseApi";
//import qs from "qs";

export const postContactUsForm = async formData => {
  const result = await BaseApi.post(
    `/ReservationProcess/SendContactMailByPost?lang=${formData.lang}`,
    formData.emailModel
  );
  return result;
};



// WEBPACK FOOTER //
// ./src/api/contactUs.js